// constants.js
export const s3ApiUrl='https://prod-media-file.s3.amazonaws.com/';
export const ociApiUrl=' https://objectstorage.ap-hyderabad-1.oraclecloud.com/n/axp78uppvvrl/b/';

export const API_KEY = 'cxTSXvdLseAdJxQvHy0MTx3X7VoHlqSX4o3HCe-OAlc';
export var API_BASE_URL,HOST_NAME;
if(window.location.hostname=="localhost"){
      API_BASE_URL = 'http://127.0.0.1:8000/api/v1/';
      HOST_NAME='localhost:8000'
}
else if(window.location.hostname=="memyfolks.com"){
      API_BASE_URL = 'https://memyfolks.com/api/v1/';
      HOST_NAME='memyfolks.com'
}
else if(window.location.hostname=="stage.memyfolks.com"){
      API_BASE_URL = 'https://stage.memyfolks.com/api/v1/';
      HOST_NAME='stage.memyfolks.com'
}
//export const API_BASE_URL = 'https://memyfolks.com/api/v1/';
// export const API_BASE_URL = 'https://memyfolks.com/api/v1/';

// export const API_BASE_URL = 'https://vigilant-fire-28759.pktriot.net/api/v1/'


export const MAX_RESULTS = 10;
export const MAX_DOWNLOAD_LIMIT=2;
console.log(window.location.hostname)
